import React, { useEffect, useState } from 'react';
import { apiGet } from '../../lib/api';
import { Laptop } from 'lucide-react';

/** Read-only IT assets currently/previously allocated to an employee.
 *  Embedded as a tab on the EmployeeMaster detail. Props: empId. */
export default function EmployeeITAssets({ empId }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    if (!empId) return;
    apiGet(`/it/employees/${empId}/assets`).then(setData).catch(() => setData({ active: [], returned: [] }));
  }, [empId]);

  if (!data) return <div className="text-slate-400 text-sm py-6">Loading…</div>;
  const active = data.active || [];
  const returned = data.returned || [];

  return (
    <div className="space-y-4" data-testid="employee-it-assets">
      <h3 className="font-display font-bold text-sm flex items-center gap-2"><Laptop size={16} /> IT Assets</h3>
      {active.length === 0 && returned.length === 0 ? (
        <div className="text-center py-8 text-slate-400 text-sm" data-testid="emp-it-assets-empty">No IT assets allocated to this employee.</div>
      ) : (
        <>
          <div>
            <div className="text-[10px] font-display font-bold uppercase tracking-wider text-slate-500 mb-2">Currently Allocated ({active.length})</div>
            {active.length === 0 ? <div className="text-xs text-slate-400">None.</div> : (
              <div className="bg-white border border-slate-200 rounded-sm divide-y divide-slate-100">
                {active.map((a) => (
                  <div key={a.id} className="px-3 py-2 flex items-center justify-between text-xs" data-testid={`emp-it-active-${a.id}`}>
                    <span><span className="font-mono text-[10px] text-slate-400">{a.asset_tag}</span> <span className="font-display font-bold">{a.asset_name}</span> <span className="text-slate-400">· {a.asset_category}</span></span>
                    <span className="text-slate-500">{a.expected_return_date ? `due ${a.expected_return_date}` : 'allocated'}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
          {returned.length > 0 && (
            <div>
              <div className="text-[10px] font-display font-bold uppercase tracking-wider text-slate-400 mb-2">Returned ({returned.length})</div>
              <div className="bg-slate-50 border border-slate-200 rounded-sm divide-y divide-slate-100">
                {returned.map((a) => (
                  <div key={a.id} className="px-3 py-2 flex items-center justify-between text-xs text-slate-500" data-testid={`emp-it-returned-${a.id}`}>
                    <span><span className="font-mono text-[10px]">{a.asset_tag}</span> {a.asset_name}</span>
                    <span>{(a.returned_at || '').slice(0, 10)}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
